import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CRISIS_PARAMS, CRISIS_TEXT_LINE_KEYS, crisisTextLines } from '@/features/chat-trf/crisis/resources';

// Spec 12 §7.1 — rendered from this fixed template, NEVER AI-generated and
// NEVER hideable by a user setting. The lines and their params live beside
// CRISIS_RESOURCES (#2109 R3-B8).
interface Props { variant?: 'full' | 'inline-link'; }

export function CrisisDisclosure({ variant = 'full' }: Props) {
  const { t } = useTranslation('crisis');
  if (variant === 'inline-link') {
    return (
      <Link to="/legal/safety" className="crisis-inline-link">
        {t('disclosure.inlineLink', CRISIS_PARAMS)}
      </Link>
    );
  }
  return (
    <section className="crisis-disclosure" role="note" aria-label={t('disclosure.ariaLabel')}>
      {crisisTextLines(t).map((line, i) => (
        <p key={CRISIS_TEXT_LINE_KEYS[i]} className={i === 0 ? 'crisis-disclosure__lede' : undefined}>{line}</p>
      ))}
    </section>
  );
}
